import { Trans } from 'react-i18next'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { BuyPremiumIcon } from '@root/entities/premium/ui'
import { DomUtil } from '@root/shared'
import BG_ARROWS from '@root/shared/assets/banner-premium.inline.svg'
import { useTranslation } from '@root/shared/localization'

type ProfilePremiumListHeaderProps = {
  noActivePremium?: boolean
}

export const ProfilePremiumListHeader: React.FC<
  ProfilePremiumListHeaderProps
> = ({ noActivePremium }) => {
  const { t } = useTranslation()

  return (
    <Root>
      <Header>
        <Group>
          <BuyPremiumIcon product="subscription" size={73} />
          <Title>
            <Trans
              i18nKey="profile.welcome.buy_premium"
              components={[<Highlight key={0} />]}
            />
          </Title>
        </Group>
        {noActivePremium ? (
          <Empty>{t('profile.welcome.no_active_premium_tokens')}</Empty>
        ) : undefined}
      </Header>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  place-content: start;
  justify-content: center;
  justify-items: center;
  align-content: end;
`

const Header = styled.div`
  background-image: ${DomUtil.cssUrl(BG_ARROWS)};
  background-repeat: no-repeat;
  background-position: 50% 17%;

  display: grid;
  place-self: center;

  grid-template-rows: 1fr auto;
  margin-bottom: 10px;
`

const Group = styled.div`
  display: grid;
  place-content: start;
  justify-content: center;
  justify-items: center;

  gap: 30px;
  padding-top: 55px;
`

const Title = styled(Typography).attrs({
  variant: 'h4',
  component: 'div',
})`
  color: var(--text-12);
  text-align: center;
`

const Highlight = styled(Typography).attrs({
  variant: 'h3',
  component: 'span',
})`
  width: 100%;
  display: table;
  height: 36px;
  flex-shrink: 0;
  align-self: stretch;

  background: linear-gradient(
    90deg,
    var(--subscriptionGradientFrom-9) 42.67%,
    var(--subscriptionGradientTo-9) 100%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

const Empty = styled(Typography).attrs({
  variant: 'body4-medium',
  component: 'span',
})`
  color: var(--textA-9);
  text-align: center;
  margin-top: 8px;
  margin-bottom: 16px;
`
